module.exports = __webpack_public_path__ + "static/media/security-industry.03778273.png";